import { render, staticRenderFns } from "./summary-page.vue?vue&type=template&id=797ef16f&scoped=true&"
import script from "./summary-page.vue?vue&type=script&lang=js&"
export * from "./summary-page.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "797ef16f",
  null
  
)

export default component.exports